const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
const QUIET_ZONE_MODULES = 4;
export function renderQrCode(modules, payload) {
    const moduleCount = modules.length;
    if (moduleCount === 0 || modules.some((row) => row.length !== moduleCount)) {
        throw new TypeError("QR module matrix must be non-empty and square");
    }
    const size = moduleCount + (QUIET_ZONE_MODULES * 2);
    const svg = document.createElementNS(SVG_NAMESPACE, "svg");
    svg.dataset.qrPayload = payload;
    svg.setAttribute("aria-label", "Pairing QR code");
    svg.setAttribute("role", "img");
    svg.setAttribute("shape-rendering", "crispEdges");
    svg.setAttribute("viewBox", `0 0 ${size} ${size}`);
    const background = document.createElementNS(SVG_NAMESPACE, "rect");
    background.setAttribute("fill", "#ffffff");
    background.setAttribute("height", String(size));
    background.setAttribute("width", String(size));
    svg.append(background);
    for (let row = 0; row < moduleCount; row += 1) {
        for (let column = 0; column < moduleCount; column += 1) {
            if (modules[row]?.[column] !== true)
                continue;
            const module = document.createElementNS(SVG_NAMESPACE, "rect");
            module.setAttribute("fill", "#000000");
            module.setAttribute("height", "1");
            module.setAttribute("width", "1");
            module.setAttribute("x", String(column + QUIET_ZONE_MODULES));
            module.setAttribute("y", String(row + QUIET_ZONE_MODULES));
            svg.append(module);
        }
    }
    return svg;
}
//# sourceMappingURL=qr-code.js.map